import { getBlobFile, getBlobFiles } from './blob';
import FileDownload from 'js-file-download';
import Cookies from 'js-cookie';

const getCompanyName = () => Cookies.get('cp-cn');

export const getDownloadCenterFiles = (pagingParams) =>
  getBlobFiles(getCompanyName(), pagingParams);


export const downloadFiles = async (files) => {
  for (const file of files) {
    const { data } = await getBlobFile(file.fileName);
    FileDownload(data, file.displayName);
  }
};

